import classNames from 'classnames'
import React, { useCallback } from 'react'
import { Column } from 'react-table'
import { Table, TableProps } from 'scenes/Dashboard/components-next/Table'
import { makeStyles } from 'tss-react/mui'

import { Paper, TablePagination, Theme } from '@mui/material'

import { ScoutingCampaign } from '../../../../../../entities-next/scoutingCampaign'
import { useScoutingCampaignDataRows } from './ScoutingCampaignRow.data'

export const ScoutingCampaignTable = React.memo(
  ({
    className,
    data,
    currentPage,
    limit,
    onChangePage,
    onRowSelect,
    extraColumns = [],
  }: ScoutingCampaignTableTableProps) => {
    const { classes } = useStyles()
    const columns = useScoutingCampaignDataRows(extraColumns)

    // TODO: Wait for the real count from back
    const hardcodedCount = getHardcodedCount(data, currentPage, limit)
    const handlePageChange = useCallback(
      (event: any, page: number) => {
        // Due to a bug of material UI, tables fire this callback on re-renders
        if (Boolean(event)) {
          onChangePage(page)
        }
      },
      [onChangePage]
    )
    const tablePagination = (keyPrefix: string, borderBottom: boolean = true) => (
      <table className={classNames(className, classes.paginationTable)}>
        <tbody>
          <tr>
            <TablePagination
              className={classNames(className, classes.pagination, !borderBottom ? classes.removeBorderBottom : '')}
              key={keyPrefix + currentPage}
              count={hardcodedCount}
              rowsPerPage={limit}
              page={currentPage}
              rowsPerPageOptions={[]}
              backIconButtonProps={{ 'aria-label': 'Previous Page' }}
              nextIconButtonProps={{ 'aria-label': 'Next Page' }}
              onPageChange={handlePageChange}
            />
          </tr>
        </tbody>
      </table>
    )

    return (
      <Paper elevation={2} className={classNames(className, classes.root)}>
        {tablePagination('top-pagination-')}
        <Table<ScoutingCampaign> className={classes.table} columns={columns} data={data} onRowSelect={onRowSelect} />
        {tablePagination('bottom-pagination-', false)}
      </Paper>
    )
  }
)

export type ScoutingCampaignTableTableProps = Omit<TableProps<ScoutingCampaign>, 'columns' | 'shouldHighlight'> & {
  currentPage: number
  limit: number
  onChangePage: (page: number) => void
  extraColumns?: Column<ScoutingCampaign>[]
}

ScoutingCampaignTable.displayName = 'ScoutingCampaignTable'

function getHardcodedCount(data: ScoutingCampaign[], currentPage: number, limit: number) {
  return limit > data.length ? data.length : limit * (currentPage + 1) + 1
}

const useStyles = makeStyles()(({ palette }: Theme) => ({
  root: {
    width: '100%',
    overflowX: 'auto',
  },
  table: {
    tableLayout: 'fixed',
  },
  paginationTable: {
    width: '100%',
  },
  pagination: {
    width: '100%',
    display: 'flex',
  },
  removeBorderBottom: {
    borderBottom: `0px solid ${palette.grey[400]}`,
  },
}))
